// src/utils/api.js
const BASE_URL = process.env.REACT_APP_DB_BASE_URL || 'http://localhost/api';

export const client = {
  async request(endpoint, method = 'GET', data = null, id = null) {
    let url = `${BASE_URL}/${endpoint}`;
    if (id !== null) {
      url += `?id=${id}`;
    }

    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    const config = {
      method,
      headers: isFormData ? {} : { 'Content-Type': 'application/json' },
      credentials: 'include'
    };

    if (data && (method === 'POST' || method === 'PUT')) {
      config.body = isFormData ? data : JSON.stringify(data);
    }

    const response = await fetch(url, config);
    
    if (response.status === 204) return true; // DELETE/OPTIONS tracking
    
    const result = await response.json();
    if (!response.ok || !result.ok) {
      throw new Error(result.error || `HTTP error! status: ${response.status}`);
    }
    return result;
  },

  get(endpoint, id = null) { return this.request(endpoint, 'GET', null, id); },
  post(endpoint, data) { return this.request(endpoint, 'POST', data); },
  put(endpoint, id, data) { return this.request(endpoint, 'PUT', data, id); },
  delete(endpoint, id) { return this.request(endpoint, 'DELETE', null, id); }
};